import { gql } from '@apollo/client';

import { CourseActivityByMonth } from '@ts-core/modules/billing/types';

export interface GetCourseActivityByMonthQueryVariables {
  courseId: string;
  year: string;
  month: string;
}

export interface GetCourseActivityByMonthQueryResult {
  courseActivity: CourseActivityByMonth;
}

export const getCourseActivityByMonthQuery = gql`
  query GetCourseActivityByMonth($courseId: String!, $year: String!, $month: String!) {
    courseActivity(courseId: $courseId, year: $year, month: $month)
      @rest(type: "CourseActivityByMonth", path: "students-activity/years/{args.year}/months/{args.month}/courses/{args.courseId}") {
      _id
      name
      year
      month
      students
      academy
      professor
      activityAnswers
      mediaSessions
      documents
      practiceSessions
      assignmentAnswers
    }
  }
`;
